"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Line = void 0;
const simple_features_js_1 = require("@ngageoint/simple-features-js");
const GridUtils_1 = require("../GridUtils");
const Unit_1 = require("./Unit");
/**
 * Line between two points
 */
class Line extends simple_features_js_1.Line {
    /**
     * Create a line
     *
     * @param point1
     *            first point
     * @param point2
     *            second point
     * @return line
     */
    static line(point1, point2) {
        const line = new Line();
        line.setPoints(point1, point2);
        return line;
    }
    /**
     * Get the first point
     *
     * @return first point
     */
    getPoint1() {
        return this.startPoint();
    }
    /**
     * Set the first point
     *
     * @param point1
     *            first point
     */
    setPoint1(point1) {
        this.setPoints(point1, this.getPoint2());
    }
    /**
     * Get the second point
     *
     * @return second point
     */
    getPoint2() {
        return this.endPoint();
    }
    /**
     * Set the second point
     *
     * @param point2
     *            second point
     */
    setPoint2(point2) {
        this.setPoints(this.getPoint1(), point2);
    }
    /**
     * Set the points
     *
     * @param point1
     *            first point
     * @param point2
     *            second point
     */
    setPoints(point1, point2) {
        this.points = [point1, point2];
        this.validateUnits();
    }
    /**
     * Get the unit
     *
     * @return unit
     */
    getUnit() {
        return this.getPoint1().getUnit();
    }
    /**
     * Is in the provided unit type
     *
     * @param unit
     *            unit
     * @return true if in the unit
     */
    isUnit(unit) {
        return this.getPoint1().isUnit(unit);
    }
    /**
     * Is this line in degrees
     *
     * @return true if degrees
     */
    isDegrees() {
        return this.getPoint1().isDegrees();
    }
    /**
     * Is this line in meters
     *
     * @return true if meters
     */
    isMeters() {
        return this.getPoint1().isMeters();
    }
    /**
     * Convert to the unit
     *
     * @param unit
     *            unit
     * @return point in units, same point if equal units
     */
    toUnit(unit) {
        let line;
        if (this.isUnit(unit)) {
            line = this;
        }
        else {
            line = this.copy();
            line.setPoints(this.getPoint1().toUnit(unit), this.getPoint2().toUnit(unit));
        }
        return line;
    }
    /**
     * Convert to degrees
     *
     * @return line in degrees, same line if already in degrees
     */
    toDegrees() {
        return this.toUnit(Unit_1.Unit.DEGREE);
    }
    /**
     * Convert to meters
     *
     * @return line in meters, same line if already in meters
     */
    toMeters() {
        return this.toUnit(Unit_1.Unit.METER);
    }
    /**
     * Get the intersection between this line and the provided line
     *
     * @param line
     *            line
     * @return intersection
     */
    intersection(line) {
        return GridUtils_1.GridUtils.lineIntersection(this, line);
    }
    /**
     * Copy the line
     *
     * @return line copy
     */
    copy() {
        return new Line(this);
    }
    /**
     * Validate units are the same
     */
    validateUnits() {
        if (!this.getPoint1().isUnit(this.getPoint2().getUnit())) {
            throw new Error('Points are in different units. point1: ' +
                this.getPoint1().getUnit() +
                ', point2: ' +
                this.getPoint2().getUnit());
        }
    }
}
exports.Line = Line;
//# sourceMappingURL=Line.js.map